import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

const DashboardActions = ({hints, toggleAbsolute}) => (
    <div className="btn-group">
        <button className={classNames('btn btn-outline-primary btn-sm', {active: !hints.absolute})} onClick={toggleAbsolute}>
            <FontAwesomeIcon icon="percent" />
        </button>
    </div>
);

export default DashboardActions;
